import { SlideOpening } from './SlideOpening'
import { SlideExperienced } from './SlideExperienced'
import { SlideModel } from './SlideModel'
import { SlideJourney } from './SlideJourney'
import { SlideSnakify } from './SlideSnakify'
import { SlideChannels } from './SlideChannels'
import { SlideConversation } from './SlideConversation'
import { SlideSignals } from './SlideSignals'
import { SlideCampaign } from './SlideCampaign'
import { SlideLearning } from './SlideLearning'
import { SlidePeer } from './SlidePeer'
import { SlideExecution } from './SlideExecution'
import { SlideClosing } from './SlideClosing'
import type { SlideId } from './SlideShell'

/** Ferring × Snakker — the REKOVELLE deck, presented in this order. */
export const slides = [
  SlideOpening,
  SlideExperienced,
  SlideModel,
  SlideJourney,
  SlideSnakify,
  SlideChannels,
  SlideConversation,
  SlideSignals,
  SlideCampaign,
  SlideLearning,
  SlidePeer,
  SlideExecution,
  SlideClosing,
]

export const slideTitles: { id: SlideId; section: string; title: string }[] = [
  { id: 'opening', section: '01', title: 'REKOVELLE × Snakker' },
  { id: 'experienced', section: '02', title: 'Short. Sharp. Rewarding.' },
  { id: 'model', section: '03', title: 'Attention → Understanding → Action' },
  { id: 'journey', section: '04', title: 'Promise → Effort → Reward → Next step' },
  { id: 'snakify', section: '05', title: 'What Could We Snakify?' },
  { id: 'channels', section: '06', title: 'One Experience. Many Channels.' },
  { id: 'conversation', section: '07', title: 'Turn Communication into Conversation' },
  { id: 'signals', section: '08', title: 'Every Interaction Creates a Signal' },
  { id: 'campaign', section: '09', title: 'From Snak to Campaign' },
  { id: 'learning', section: '10', title: 'The More We Activate, the More We Learn' },
  { id: 'peer', section: '11', title: 'Optional Peer Mode' },
  { id: 'execution', section: '12', title: 'From Asset to Execution' },
  { id: 'closing', section: '13', title: 'Where Could REKOVELLE Benefit?' },
]
